<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TabContentWrapper",
  props: {
    id: {
      type: String,
      required: true,
    },
  },
};
</script>
